import { STRINGS } from '../../constants';
import apiCaller from '../http';
import URLS from '../urls';

const fetchWorkshopReviews = async (workshopId, saveReviews, setError, logoutHandler) => {
  await apiCaller
    .get(`${URLS.WORKSHOP_REVIEWS_LIST}${workshopId}/`)
    .then((response) => {
      if (response.data !== undefined) {
        setError(null);
        saveReviews(response.data);
      } else {
        setError(STRINGS.common.error404Text);
      }
    })
    .catch((e) => {
      if (e.message === STRINGS.common.errorMissingCredentials) {
        logoutHandler();
      }
      if (e.message === STRINGS.common.error400Template) {
        setError(STRINGS.common.error400Text);
      }
      setError(STRINGS.common.error404Text);
    });
};

export default fetchWorkshopReviews;
